import { getTheme, concatStyleSets } from "@uifabric/styling";
import { memoizeFunction } from "@uifabric/utilities";
var defaultStyles = function (theme) {
    return {
        root: {},
        editor: {
            padding: 8
        },
        actions: {},
        action: {
            marginRight: 8
        }
    };
};
var Defaults = {
    styles: defaultStyles
};
var getStyles = memoizeFunction(function (theme, customStyles) {
    return concatStyleSets(Defaults.styles(theme || getTheme()), customStyles);
});
export { getStyles, defaultStyles, Defaults };
